import { SharedKPIWidget } from '../shared/kpi/SharedKPIWidget';
import { WidgetConfig } from '../../infrastructure/contracts/widget.contract';
import { useAdminConvertedAdapter } from './adapters/adminKpiAdapters';

export const adminConvertedConfig: WidgetConfig = {
  id: 'admin-converted-leads',
  title: 'Converted',
  icon: 'check_circle',
  category: 'statistics',
  description: 'Number of converted leads',
  refreshStrategy: 'interval',
  defaultSize: { w: 2, h: 1 },
  priority: 6,
  supportedRoles: ['admin', 'superadmin'],
};

export function AdminConvertedWidget() {
  const dataQuery = useAdminConvertedAdapter();

  return (
    <SharedKPIWidget
      config={adminConvertedConfig}
      dataQuery={dataQuery}
      color="success"
    />
  );
}
